/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import Dropdown from '@components/v2/Dropdown';
import { FireIcon } from '@icons/FireIcon';
import { namespace } from '../constants';
import './ResourceSelectorStyles.scss';
import RichResourceActions from './RichResourceActions';
export default function ResourceSelector({ entryId, resources, selectedResourceId, onDeleteEntry, onResourceSelect, onUpdateResource, placeholder = 'Select a resource', disabled = false, isLoading = false, error = null }) {
    // Transform resources into dropdown format
    const resourceOptions = resources.map((resource) => ({
        value: resource.id.toString(),
        label: resource.name
    }));
    // Add empty option to allow clearing selection
    const allOptions = [
        { value: '', label: translate('content_sections.no_selection', { namespace }) },
        ...resourceOptions
    ];
    const selectedValue = selectedResourceId ? selectedResourceId.toString() : '';
    const handleResourceChange = (value) => {
        if (value && value !== '') {
            const resourceId = parseInt(value, 10);
            onResourceSelect(resourceId);
        }
    };
    const selectedResource = resources.find((r) => r.id === selectedResourceId);
    return (React.createElement("div", { className: "resource-selector-container", role: "group", "aria-labelledby": `resource-selector-label-${entryId || ''}` },
        React.createElement("div", { className: `resource-selector ${isLoading ? 'loading' : ''} ${error ? 'has-error' : ''}`, role: "group", "aria-label": translate('content_sections.select_template', { namespace }) },
            React.createElement("div", { className: "resource-dropdown-container" },
                React.createElement(FireIcon, null),
                React.createElement(Dropdown, { resourceOptions: allOptions, resourceName: translate('content_sections.type', { namespace }), selectedItem: selectedValue, showLabel: true, inlineLabel: true, allowEmpty: true, emptyLabel: placeholder, disabled: disabled, "aria-label": placeholder, "aria-describedby": error ? 'resource-selector-error' : undefined, onChange: handleResourceChange })),
            React.createElement(RichResourceActions, { resourceName: (selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.name) || '', onEditResource: () => {
                    if (selectedResource === null || selectedResource === void 0 ? void 0 : selectedResource.id) {
                        onUpdateResource(selectedResource.id);
                    }
                }, onDeleteEntry: () => {
                    onDeleteEntry(entryId);
                } }),
            isLoading && (React.createElement("div", { className: "resource-loading-state", role: "status", "aria-live": "polite" },
                React.createElement("span", { className: "loading-text" }, translate('content_sections.loading_resources', { namespace })))),
            !isLoading && !error && resources.length === 0 && (React.createElement("div", { className: "resource-empty-state", role: "status" },
                React.createElement("span", { className: "empty-state-text" }, translate('content_sections.no_resources', { namespace })))))));
}
